import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import {FormGroup, FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {ProductItem} from '../../../models/product';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Lot} from 'src/app/models/lot';
import {AnnuityLotDialogComponent} from '../annuity-lot-dialog/annuity-lot-dialog.component';
import {AnnuityLotService} from 'src/app/services/annuity-lot.service';
import {RefundService} from 'src/app/services/refund.service';
import {BannerDialogComponent} from 'src/app/event/dialogs/banner-dialog/banner-dialog.component';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';
import {AnnuityService} from 'src/app/services/annuity.service';
import {Annuity} from 'src/app/models/annuity';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-annuity-dialog',
  templateUrl: './annuity-dialog.component.html',
  styleUrls: [ './annuity-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})

export class AnnuityDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public matcher = new FormErrorStateMatcher();
  public productForm: FormGroup;
  public itemForm: FormGroup;

  public displayedItemColumns: string[] = [ 'icon', 'event_name', 'delete' ];
  public displayedLotColumns: string[] = [ 'icon', 'until_date', 'name', 'edit', 'delete' ];
  public displayedCatProductColumns: string[] = [ 'icon', 'name', 'value', 'limit', 'edit', 'delete' ];
  public displayedRefundColumns: string[] = [ 'icon', 'date', 'percent', 'edit', 'delete' ];

  public productItemAdded: ProductItem;
  public selectedItemOk: boolean = false;

  public allProducts: any[] = [];

  public selectedRequiredProduct: any = {};
  public selectedRequiredProduct_id: any

  public displayedRequirementsColumns: string[] = [ 'icon', 'name', 'delete' ];

  public part_of_list: any[] = []

  @ViewChild(MatSort, {static: false}) sort: MatSort;

  public sponsorsDataSource: MatTableDataSource<any>
  public displayedSponsorColumns: string[] = [ 'image', 'link', 'type', 'delete' ];

  constructor (
    private fs: AngularFireStorage,
    private dialog: MatDialog,
    public _annuityService: AnnuityService,
    public _refundService: RefundService,
    public _annuityLotService: AnnuityLotService,
    private _adapter: DateAdapter<any>,
    private snackBar: SnackBarIconService,
    @Inject(MAT_DIALOG_DATA) public data: Annuity) {

    if (this.data.id)
      this._refundService.loadRefunds(this.data.id);

  }


  ngOnInit () {
    // console.log("product_id: " + this.data.id)
    this._adapter.setLocale('pt');

    this._annuityService.currentAnnuity = this.data;
    //this._productService.productRequirementsDataSource = new MatTableDataSource(this._productService.currentProduct.requirements);

    this._annuityService.storedImage = this._annuityService.currentAnnuity.image
    this._annuityService.storedImage_en = this._annuityService.currentAnnuity.image_en

    this._annuityService.storedButton = this._annuityService.currentAnnuity.button
    this._annuityService.storedButton_en = this._annuityService.currentAnnuity.button_en

    this._annuityService.setEdit()

    this._annuityService.productItensDataSource = new MatTableDataSource([]);

    this.productForm = this._annuityService.createForm(this._annuityService.currentAnnuity)
    this.itemForm = this._annuityService.createItemForm();

    this.loadBannerSponsors();
  }

  ngAfterViewInit () {

    this._annuityService.loadEvents()

    if (this._annuityService.isEdit) {
      this._annuityService.loadProductItens(this._annuityService.currentAnnuity.id)
      this._annuityLotService.loadProductLots(this._annuityService.currentAnnuity.id, this.sort)
    }

  }

  insert () {
    if (this.productForm.valid) {
      let newProduct = this.productForm.getRawValue()
      const entity = this._annuityService.createProduct(newProduct)
      this._annuityService.insert(entity)
    }
  }

  update () {
    if (this.productForm.valid) {
      let updatedProduct = this.productForm.getRawValue()
      const entity = this._annuityService.createProduct(updatedProduct)
      this._annuityService.update(entity)
    }
  }

  deleteLot (element: any) {
    console.log(element.id)
  }

  updateChecks () {

    this._annuityService.updateChecks(
      this._annuityService.currentAnnuity.id,
      this.productForm.controls.active.value || false
    )

  }

  openLotDialog (element) {

    let data: Lot = new Lot();

    if (element) {
      data = element;
    }

    this.dialog.open(AnnuityLotDialogComponent, {
      width: '850px',
      height: '570px',
      panelClass: 'custom-dialog-container',
      data: {lot: data, product: this._annuityService.currentAnnuity}
    });
  }

  loadBannerSponsors () {
    if (this._annuityService.currentAnnuity.sponsors && this._annuityService.currentAnnuity.sponsors.length > 0) {
      //  console.log('this._productService.currentProduct.sponsors ' + JSON.stringify(this._productService.currentProduct.sponsors))
      this.sponsorsDataSource = new MatTableDataSource(this._annuityService.currentAnnuity.sponsors)
    }
  }

  updateBannerSponsor (banner) {

    if (!this._annuityService.currentAnnuity.sponsors) {
      this._annuityService.currentAnnuity.sponsors = []
    }

    this._annuityService.currentAnnuity.sponsors.push(banner)
    this.sponsorsDataSource = new MatTableDataSource(this._annuityService.currentAnnuity.sponsors)

    this._annuityService.updateBannerSponsor(this._annuityService.currentAnnuity.id, this._annuityService.currentAnnuity.sponsors)

  }

  removeBannerSponsor (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.link + "<br><br>Excluir este banner?"}
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {
        this._annuityService.currentAnnuity.sponsors = this._annuityService.currentAnnuity.sponsors.filter((e) => {
          return e.id != element.id;
        })

        this.sponsorsDataSource = new MatTableDataSource(this._annuityService.currentAnnuity.sponsors)
        //  console.log("this._eventService.currentEvent.sponsors: " + JSON.stringify(this._eventService.currentEvent.sponsors))
        this._annuityService.updateBannerSponsor(this._annuityService.currentAnnuity.id, this._annuityService.currentAnnuity.sponsors)
          .then(() => {

            const fsRef: any = this.fs.storage.refFromURL(element.image);
            fsRef.delete();

          })

      }
      else {
        return result
      }

    })


  }

  openBannerDialog () {

    let dialogRef = this.dialog.open(BannerDialogComponent, {
      width: '600px',
      height: '470px',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: {'isProduct': true}
    })

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const bannerForm: FormGroup = response[ 0 ];
        const objectBanner: any = response[ 1 ];

        const formData = bannerForm.getRawValue();

        let banner: any = {};

        banner.id = new Date().getTime();
        banner.link = formData.link || '';
        banner.type = Number(formData.type)

        const fsRef: AngularFireStorageReference = this.fs.ref("images/banner_sponsors/" + "banner_" + banner.id + ".png");
        const fsTask: AngularFireUploadTask = fsRef.put(objectBanner);

        fsTask.snapshotChanges().pipe(
          finalize(() => {
            fsRef.getDownloadURL().subscribe(url => {
              banner.image = url;
              this.updateBannerSponsor(banner);
            });
          }))
          .subscribe();
      })
  }

  selectItem (event) {

    if (event) {
      this.selectedItemOk = true
    }
    const evt = this._annuityService.arrayEvents.find(function (e) {
      return e.id == event;
    });

    this.productItemAdded = new ProductItem();
    this.productItemAdded.event_id = evt.id;
    this.productItemAdded.event_name = evt.name;
    this.productItemAdded.product_id = this._annuityService.currentAnnuity.id;
  }


  addItem () {
   // console.log("productItemAdded: " + JSON.stringify(this.productItemAdded))
    this._annuityService.addItem(this.productItemAdded);
    this.productItemAdded = null;
  }


  removeItem (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.event_name + "<br><br>Remover este evento?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._annuityService.deleteItem(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete event item  error: " + error.message)}
          )
      }
    })
  }

}